import options from '~/components/Select/options';

export interface NotificationsFormValues {
  autoEmailNotifications: boolean;
  autoDeliveredEmailNotifications: boolean;
  autoOrderEmailDelayMinutes: Maybe<number>;
  autoOrderEmailCustomText: Maybe<string>;
  autoDeliveredEmailCustomText: Maybe<string>;
}

export enum NotificationType {
  Shipped = 'UNKNOWN',
  Delivered = 'DELIVERED',
}

export enum EmailSections {
  Branding = 'BRANDING',
  OrderShipped = 'ORDER_SHIPPED',
  OrderArrived = 'ORDER_ARRIVED',
}

export type NotificationConfig = {
  UNKNOWN?: ShippedNotificationConfig;
  DELIVERED?: DeliveredNotificationConfig;
};

export type ShippedNotificationConfig = {
  is_auto_email_enabled: boolean;
  auto_email_delay_minutes: Maybe<number>;
  custom_text: Maybe<string>;
};

export type DeliveredNotificationConfig = {
  is_auto_email_enabled: boolean;
  custom_text: Maybe<string>;
};

export interface NotificationsPayload {
  notification_configs: NotificationConfig;
}

export interface OrderShippedFormFields {
  orderShippingEmailEnabled: boolean;
  orderShippingEmailContent: string;
  orderShippingEmailSubject: string;
  orderShippingEmailDelaySendDuration: number;
}

export interface OrderArrivedFormFields {
  orderArrivedEmailEnabled: boolean;
  orderArrivedEmailContent: string;
  orderArrivedEmailSubject: string;
}

export interface OrderArrivedReengagementFormFields {
  orderArrivedSpotlightTitle: string;
  orderArrivedSpotlightUrl: string;
  orderArrivedProductRecommendationsTitle: string;
  orderArrivedProductRecommendationsUrl1: string;
  orderArrivedProductRecommendationsUrl2: string;
  orderArrivedProductRecommendationsUrl3: string;
  orderArrivedProductRecommendationsUrl4: string;
  orderArrivedPromotionsUrl: string;
}

export const orderShippedFieldsToJSON = (
  orderShippedFormFields: OrderShippedFormFields,
): NotificationConfig => {
  const delayMinutes = +(orderShippedFormFields.orderShippingEmailDelaySendDuration || 0);
  // ensure the delay option exists before crafting the request data
  const foundOption = options.notificationOptions.find((option) => {
    return +option.value === delayMinutes;
  });
  return {
    UNKNOWN: {
      is_auto_email_enabled: orderShippedFormFields.orderShippingEmailEnabled,
      custom_text: orderShippedFormFields.orderShippingEmailContent,
      auto_email_delay_minutes: foundOption ? delayMinutes : 0,
    },
  };
};

export const orderShippedFieldsFromJSON = (
  responseData: NotificationsPayload,
): OrderShippedFormFields => {
  const shippedConfig: Maybe<ShippedNotificationConfig> = responseData.notification_configs.UNKNOWN;
  return {
    orderShippingEmailEnabled: !!shippedConfig?.is_auto_email_enabled,
    orderShippingEmailDelaySendDuration: +(shippedConfig?.auto_email_delay_minutes || 0),
    orderShippingEmailContent: shippedConfig?.custom_text || '',
    orderShippingEmailSubject: '',
  };
};

export const orderArrivedFieldsToJSON = (
  orderArrivedFormFields: OrderArrivedFormFields,
): NotificationConfig => {
  return {
    DELIVERED: {
      is_auto_email_enabled: orderArrivedFormFields.orderArrivedEmailEnabled,
      custom_text: orderArrivedFormFields.orderArrivedEmailContent,
    },
  };
};

export const orderArrivedFieldsFromJSON = (
  responseData: NotificationsPayload,
): OrderArrivedFormFields => {
  const shippedConfig: Maybe<DeliveredNotificationConfig> =
    responseData.notification_configs.DELIVERED;
  return {
    orderArrivedEmailEnabled: !!shippedConfig?.is_auto_email_enabled,
    orderArrivedEmailContent: shippedConfig?.custom_text || '',
    orderArrivedEmailSubject: '',
  };
};
